export default __webpack_public_path__ + "static/media/OrientalInsurance.8c038291.svg";